import { Link } from "react-router-dom";
import Img from '../image.avif';
function Nav(props) {
  var routes = [
    {
      img:Img,
      path:"/image"
    },
    {
      title: "Home",
      path: "/appleClone",
    },
    {
      title: "Store",
      path: "/Store",
    },
    {
      title: "Mac",
      path: "/Mac",
    },
    {
      title: "ipad",
      path: "/Ipad",
    },
    {
      title: "iphone",
      path: "/Iphone",
    },
    {
      title: "Watch",
      path: "/Watch",
    },
    {
      title: "Airpods",
      path: "/Airpods",
    },
    {
      title: "Tv & Home",
      path: "/TvHome",
    },
    {
      title: "Only On Apple",
      path: "/OnlyOnApple",
    },
    {
      title: "Accessories",
      path: "/Accessories",
    },
    {
      title: "Support",
      path: "/Support",
    },
    {
      title: "Contact",
      path: "/Contact",
    },
  ];

  var divStyle = {
    backgroundColor: "black",
    alignItems: "center",
    display: "flex",
    backgroundColor: "black",
    fontSize: "12px",
    position: "fixed",
    top: "0px",
    fontWeight: "bold",
    padding: "3px",
    fontFamily: "SF Pro Text,Myriad Set Pro,SF Pro Icons,Helvetica Neue,Helvetica,Arial,sans-serif",
    justifyContent: "center",
    width: "100%",
    lineheight: "3.66667",
    fontWeight: "400",
    letterSpacing: "-.01em",
    zIndex:"1"
  };


  var aStyle = {
    color: "white",
    margin: "1%",
    textDecoration: "none",
  };
  var imgStyle = {
    width: "18px"
  }
  return (
    <div style={divStyle}>
      {routes.map((route, index) => {
        return (
          <Link style={aStyle} key={index + 1} to={route.path}>
            <img src={route.img} style={imgStyle} /> 
            {route.title}
          </Link>
        );
      })}
    </div>
  );
}

export default Nav; 
